module.exports = __webpack_public_path__ + "media/brands/audi-6ee13c21.png";